export default __webpack_public_path__ + "static/media/topic-electro.2fc13e0b.png";